var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgShuffleLogoDark = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 87,
  height: 22,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#shuffle-logo-dark_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#545454",
  d: "M87 12.667c0-3.098-2.44-5.524-5.553-5.524s-5.543 2.428-5.543 5.524 2.435 5.526 5.543 5.526c1.713 0 3.287-.738 4.325-2.024.244-.303.296-.712.134-1.067a.96.96 0 0 0-.874-.57h-.066a.98.98 0 0 0-.794.425c-.614.87-1.603 1.367-2.715 1.367-1.657 0-3.105-1.198-3.442-2.847a.06.06 0 0 1 .013-.054c.008-.008.02-.024.046-.024h8.394a.48.48 0 0 0 .342-.142c.2-.21.193-.575.193-.59m-2.225-.973s-.023.023-.046.023h-6.609a.06.06 0 0 1-.046-.023.06.06 0 0 1-.01-.055c.416-1.615 1.749-2.658 3.395-2.658 1.647 0 2.913 1.043 3.33 2.658q.006.039-.011.055M29.138 10.097c-2.073-.26-3.357-.665-3.357-1.903 0-1.317 1.012-2.044 2.851-2.044 1.348 0 2.317.54 2.592 1.446.138.456.54.764 1.004.764a1.042 1.042 0 0 0 1.002-1.325c-.506-1.74-2.173-2.78-4.457-2.78-3.223 0-5.073 1.488-5.073 4.084 0 2.739 2.772 3.166 4.608 3.45h.026c2.304.43 3.473.906 3.473 2.327s-1.133 2.17-3.37 2.17c-1.408 0-2.664-.77-2.99-1.828a1.02 1.02 0 0 0-.981-.722 1.037 1.037 0 0 0-.979 1.367c.493 1.485 2.045 3.069 4.922 3.069 3.436 0 5.489-1.517 5.489-4.056 0-3.17-3.088-3.72-4.757-4.017zM40.442 7.62c-1.138 0-2.242.39-3.11 1.102a.1.1 0 0 1-.165-.077l.008-3.357a1.03 1.03 0 0 0-1.027-1.036c-.566 0-1.028.464-1.028 1.036v11.84c0 .575.463 1.041 1.033 1.041s1.032-.466 1.032-1.04v-4.602c0-1.783 1.218-3.03 2.96-3.03 2 0 2.853.926 2.853 3.097v4.525c0 .574.462 1.04 1.033 1.04h.01c.57 0 1.032-.466 1.032-1.04v-4.563c0-3.275-1.556-4.936-4.63-4.936M70.115 5.606h.364a.84.84 0 0 0 .637-.259.9.9 0 0 0 .265-.639c0-.497-.4-.9-.894-.9h-.737c-2.163 0-3.403 1.39-3.403 3.814v.288h-4.942v-.241c0-1.408.534-2.065 1.682-2.065h.365l.007.002a.894.894 0 0 0 .894-.9c0-.498-.4-.901-.894-.901h-.727c-1.27 0-3.403.494-3.403 3.815v.287h-1.076a.93.93 0 0 0-.927.934c0 .515.416.935.927.935h1.076v7.345c0 .575.465 1.046 1.038 1.046s1.038-.469 1.038-1.046V9.776h4.942v7.345c0 .575.464 1.046 1.045 1.046.58 0 1.038-.469 1.038-1.046V9.776h1.977c.511 0 .928-.42.928-.935a.93.93 0 0 0-.928-.934h-1.985v-.24c0-1.39.555-2.066 1.693-2.066zM73.639 4.23c-.57 0-1.033.465-1.033 1.04v11.859c0 .574.462 1.04 1.032 1.04s1.033-.466 1.033-1.04V5.269c0-.574-.462-1.04-1.033-1.04M55.23 7.149c-.57 0-1.033.468-1.033 1.04v4.791c0 2.213-.932 3.287-2.851 3.287s-2.843-1.077-2.843-3.287V8.19c0-.575-.465-1.041-1.033-1.041a1.04 1.04 0 0 0-1.032 1.04v4.84c0 3.295 1.744 5.112 4.91 5.112 3.168 0 4.92-1.814 4.92-5.112V8.19c0-.574-.465-1.04-1.033-1.04z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#shuffle-logo-dark_svg__b)",
  d: "M16.678 11.585a1.347 1.347 0 0 0 1.345-1.356c0-.376-.151-.715-.392-.96a1.33 1.33 0 0 0-.602-.35L4.554 5.275a2.5 2.5 0 0 0-.724-.093 2.24 2.24 0 0 0-1.475.616c-.388.367-.65.87-.706 1.434-.057.564.09 1.188.514 1.796.446.406.927.624 1.394.693l13.12 1.861z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#shuffle-logo-dark_svg__c)",
  d: "M15.198 17.564c.817 0 1.48-.668 1.48-1.491s-.614-1.437-1.387-1.486l-13.223-.862C.928 13.725 0 14.66 0 15.81s.927 2.083 2.068 2.083l13.128-.328z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#shuffle-logo-dark_svg__d)",
  d: "M13.398 2.187A1.23 1.23 0 0 0 12.64 0c-.236 0-.455.067-.642.186l-9.15 5.257a2.28 2.28 0 0 0-1.212 2.021A2.276 2.276 0 0 0 3.904 9.75c.583 0 1.128-.223 1.544-.588z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#shuffle-logo-dark_svg__e)",
  d: "M17.15 11.497c.512-.194.874-.688.874-1.268 0-.748-.604-1.356-1.346-1.356-.17 0-.332.033-.483.09L1.5 13.808A2.08 2.08 0 0 0 0 15.812c0 1.151.927 2.083 2.068 2.083.313 0 .611-.072.876-.2l14.204-6.198z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#shuffle-logo-dark_svg__f)",
  d: "M15.858 17.409c.486-.246.82-.748.82-1.333 0-.824-.663-1.491-1.48-1.491-.38 0-.727.145-.989.383l-7.038 5.847a.65.65 0 0 0-.285.538c0 .357.288.647.642.647a.63.63 0 0 0 .365-.116z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "shuffle-logo-dark_svg__b",
  x1: 9.83,
  x2: 9.83,
  y1: 5.182,
  y2: 18.84,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4D12C0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3F0A8F"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "shuffle-logo-dark_svg__c",
  x1: 8.34,
  x2: 8.34,
  y1: 5.174,
  y2: 19.15,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4D12C0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3F0A8F"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "shuffle-logo-dark_svg__d",
  x1: -0.658,
  x2: 13.143,
  y1: 10.692,
  y2: 1.103,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E300FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.68,
  stopColor: "#217BFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00F0B1"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "shuffle-logo-dark_svg__e",
  x1: 3.817,
  x2: 18.51,
  y1: 16.495,
  y2: 6.286,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E300FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.68,
  stopColor: "#217BFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00F0B1"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "shuffle-logo-dark_svg__f",
  x1: 7.066,
  x2: 19.33,
  y1: 21.814,
  y2: 13.293,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E300FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.68,
  stopColor: "#217BFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00F0B1"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "shuffle-logo-dark_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h87v22H0z"
})))));
export default SvgShuffleLogoDark;